export function emptyf() {}

export function countLineBreaks(str: string): number {
  return str.split('').reduce((accumulated: number, char: string) => {
    if (char === '\n') {
      return accumulated + 1;
    }
    return accumulated;
  }, 0);
}

export function sleep(millis: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, millis));
}
